import { render } from "./PayModalSectionExpenseFeeInfo.vue?vue&type=template&id=338b3382"
import script from "./PayModalSectionExpenseFeeInfo.vue?vue&type=script&lang=js"
export * from "./PayModalSectionExpenseFeeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__